import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography, Stack, Button } from '@mui/material';
import {
  getContractToSign,
  signContract,
} from '../../../../utils/axiosRequests';
import Loading from '../../../molecules/Loading';
import useQuery from '../../../../utils/queryFunctions';
import { useTranslation } from 'react-i18next';

const SignDocument = React.lazy(
  () => import('../../../../utils/SignDocument'),
);

const signatureFields = [
  {
    id: 'signature1',
    page: 5,
    x: 0.1, // position X en pourcentage de la largeur de la page
    y: 0.7, // position Y en pourcentage de la hauteur de la page
    width: 270, // largeur en pourcentage de la largeur de la page
    height: 120, // hauteur en pourcentage de la hauteur de la page
    required: true,
    label: 'Signature du client',
  },
  {
    id: 'signature2',
    page: 6,
    x: 0.2, // position X en pourcentage de la largeur de la page
    y: 0.72, // position Y en pourcentage de la hauteur de la page
    width: 250, // largeur en pourcentage de la largeur de la page
    height: 60, // hauteur en pourcentage de la hauteur de la page
    required: true,
    label: 'Signature du client',
  },
];

export default function SignerPage() {
  const { t } = useTranslation('subPro', {
    keyPrefix: 'bankContact',
  });
  let navigate = useNavigate();

  let query = useQuery();
  const request_token = query.get('request_token');

  const [errorMessage, setErrorMessage] = useState(null);

  const [pdfBlob, setPdfBlob] = useState(null);

  const [loading, setLoading] = React.useState(false);
  const [isBeingSigned, setIsBeingSigned] = React.useState(false);

  const handleSubmit = (signedPdfBlob) => {
    setIsBeingSigned(true);
    // Envoyer le PDF signé au backend
    const formData = new FormData();
    formData.append('file', signedPdfBlob, 'signed_document.pdf');
    signContract(request_token, formData)
      .then((response) => {
        navigate('/login', { replace: true });
        setIsBeingSigned(false);
      })
      .catch((error) => {
        setIsBeingSigned(false);
      });
  };

  const handleSign = () => {
    setLoading(true);
    getContractToSign(request_token).then((response) => {
      // Vérifie que la réponse est bien un Blob
      if (response.data instanceof Blob) {
        setPdfBlob(response.data);
      } else {
        setErrorMessage(
          "La réponse n'est pas un fichier PDF valide.",
        );
      }
    });
    setLoading(false);
  };

  return (
    <>
      <Stack
        spacing={2}
        sx={{ maxHeight: '100%', alignItems: 'center', p: 2 }}
      >
        {isBeingSigned ? (
          <Typography variant={'h3'}>
            Signature en cours...
          </Typography>
        ) : (
          <>
            <Typography variant={'h3'}>
              Tout est prêt, vous pouvez signer votre contrat Etiq
            </Typography>
            <Button
              onClick={handleSign}
              disabled={loading}
              color="button"
              variant="contained"
              sx={{
                margin: 'auto',
                fontSize: '20px !important',
                width: 255,
                height: 60,
              }}
            >
              {loading ? (
                <>
                  <div style={{ marginRight: '20px' }}>
                    <Loading />
                  </div>
                  Creation en cours...
                </>
              ) : (
                t('sub_sign_button')
              )}
            </Button>
            {errorMessage?.length ? (
              <Typography
                style={{
                  fontSize: '18px',
                  marginTop: '20px',
                  wordBreak: 'break-all',
                  maxHeight: '150px',
                  overflow: 'auto',
                  color: '#d32f2f',
                }}
              >
                {errorMessage}
              </Typography>
            ) : (
              pdfBlob && (
                <SignDocument
                  pdfBlob={pdfBlob}
                  signatureFields={signatureFields}
                  onSubmit={handleSubmit}
                />
              )
            )}
          </>
        )}
      </Stack>
    </>
  );
}
